// @flow @format
import {put, select, takeEvery} from 'redux-saga/effects';
import {PrivateApi} from 'lib/cloner-api';
import BlocksApi from 'lib/blocks-api';
import {
	addFileNode,
	addFileVersions,
	FETCH_FILE_NODE,
	FETCH_FILE_VERSIONS,
} from '../reducers/entities/files';

import type {FileNode} from 'lib/cloner-api';
import type {State} from '../reducers';
import type {
	FetchFileNodeAction,
	FetchFileVersionsAction,
} from '../reducers/entities/files';

function watchFetchFileNode(api: BlocksApi) {
	return function*(action: FetchFileNodeAction): Generator<*, void, *> {
		const state: State = yield select();

		if (state.entities.files.entities[action.fileId]) {
			return;
		}

		try {
			const fileNode: FileNode = yield api.getFiles(
				action.fileId,
				action.repositoryId
			);
			yield put(addFileNode(action.fileId, fileNode));
		} catch (error) {
			console.error(error);
		}
	};
}

function watchFetchFileVersions(api: PrivateApi) {
	return function*(action: FetchFileVersionsAction): Generator<*, void, *> {
		const state: State = yield select();

		if (state.entities.files.versions[action.fileId]) {
			return;
		}

		try {
			const fileNode: FileNode = yield api.getFileVersions(
				action.fileId,
				action.repositoryId
			);
			yield put(addFileVersions(action.fileId, fileNode.files));
		} catch (error) {
			console.error(error);
		}
	};
}

function makeSaga(api: PrivateApi, blocksApi: BlocksApi) {
	return function*(): Generator<*, void, *> {
		yield takeEvery(FETCH_FILE_NODE, watchFetchFileNode(blocksApi));
		yield takeEvery(FETCH_FILE_VERSIONS, watchFetchFileVersions(api));
	};
}

export default makeSaga;



// WEBPACK FOOTER //
// ./src/sagas/files.js